import colors from '@constants/colors';
import Error from '@icons/Error';
import Notice from '@icons/Notice';
import Success from '@icons/Success';
import { Toaster } from 'sonner';

const ICON_SIZE = 16;

function AppToaster() {
    return (
        <Toaster
            position='bottom-center'
            swipeDirections={['left', 'right', 'bottom']}
            mobileOffset={{ bottom: 150 }}
            visibleToasts={1}
            icons={{
                error: <Error size={ICON_SIZE} color={colors.iconError}/>,
                success: <Success size={ICON_SIZE} color={colors.iconSuccess}/>,
                info: <Notice size={ICON_SIZE} color={colors.iconNotice}/>,
            }}
            duration={2000}
            toastOptions={{
                unstyled: true,
                classNames: {
                    toast: 'toaster',
                },
            }}
        />
    );
}

export default AppToaster;
